<template>
  <section
    class="bg-black bg-opacity-50 py-8 xl:px-32 font-russo text-[20px] font-bold"
  >
    <h1 class="text-white text-[24px] md:text-[36px]">
      PRODUCE RALLY NAVIGATION ROADBOOKS
    </h1>
    <h3 class="text-white font-electro">[ CHOOSE YOUR RALLY FORMAT ]</h3>
    <section
      class="grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-8 md:gap-0 items-end mt-8 max-w-[1400px] mx-auto"
    >
      <div class="col-span-1 px-8">
        <router-link to="how-to-create-a-cross-country">
          <picture class="contents">
            <source srcset="/images/ProduceRoadbooks/funnel-toureg.webp" type="image/webp" />
            <img width="521" height="231"
            class="object-cover max-w-[105%] m-auto pb-3"
            decoding="async"
            loading="lazy"
            src="/images/ProduceRoadbooks/funnel-toureg.png"
            alt="Rally Navigator turning a GPS route into a printed roadbook"
            />
          </picture>
          <h3 class="text-white text-lg font-bold uppercase underline pt-3">
            Cross Country Rally
          </h3>
        </router-link>
      </div>
      <div class="col-span-1 px-8">
        <router-link to="time-speed-distance">
          <picture class="contents">
            <source
              srcset="/images/ProduceRoadbooks/car-isolated.webp"
              type="image/webp"
            />
            <img width="373" height="269"
              class="object-cover max-w-[90%] m-auto"
              decoding="async"
              loading="lazy"
              src="/images/ProduceRoadbooks/car-isolated.png"
              alt="Rally car"
            />
          </picture>
          <h3 class="text-white text-lg font-bold uppercase underline pt-3">
            Time Speed Distance Rally
          </h3>
        </router-link>
      </div>
      <div class="col-span-1 px-8">
        <router-link to="how-to-create-a-road-rally">
          <picture class="contents">
            <source srcset="/images/ProduceRoadbooks/funnel-subie.webp" type="image/webp" />
            <img width="430" height="265"
            class="object-cover max-w-[90%] m-auto pb-2"
            decoding="async"
            loading="lazy"
            src="/images/ProduceRoadbooks/funnel-subie.png"
            alt="Rally Navigator turning a GPS route into a digital roadbook"
            />
          </picture>
          <h3 class="text-white text-lg font-bold uppercase underline pt-3">
            Road & Stage Rally
          </h3>
        </router-link>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ProduceRoadbooks',
};
</script>

<style scoped></style>
